import { useEffect, useRef, useState } from 'react';
import { navLinks, hotSearches } from '@/mocks/home';

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchFocus, setSearchFocus] = useState(false);
  const [keyword, setKeyword] = useState('');
  const searchRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (searchRef.current && !searchRef.current.contains(event.target as Node)) {
        setSearchFocus(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/80 bg-background-50/90 backdrop-blur-md">
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 items-center justify-between gap-4">
          <div className="flex items-center gap-6 lg:gap-10">
            <h1 className="shrink-0">
              <a href="#top" className="group flex items-center gap-2.5 pointer-events-auto">
                <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50 transition-transform group-hover:scale-105">
                  <i className="ri-fire-fill text-lg" aria-hidden="true"></i>
                </span>
                <span className="flex flex-col leading-none">
                  <span className="text-base font-heading font-bold tracking-tight text-foreground-950">
                    黑料网站
                  </span>
                  <span className="mt-1 text-[10px] font-label tracking-[0.22em] uppercase text-foreground-500">
                    Entry Portal
                  </span>
                </span>
              </a>
            </h1>

            <nav className="hidden lg:flex items-center gap-1" aria-label="主导航">
              {navLinks.map((link) => (
                <a
                  key={link.id}
                  href={link.href}
                  className="whitespace-nowrap rounded-md px-3 py-2 text-sm font-label text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>

          <div className="flex items-center gap-2 md:gap-3">
            <div ref={searchRef} className="relative hidden md:block">
              <div className="flex h-10 w-48 items-center gap-2 rounded-md border border-background-200 bg-background-50 px-3 transition-colors focus-within:border-primary-300 lg:w-64">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-search-line text-sm text-foreground-500" aria-hidden="true"></i>
                </span>
                <input
                  type="text"
                  value={keyword}
                  onChange={(event) => setKeyword(event.target.value)}
                  onFocus={() => setSearchFocus(true)}
                  placeholder="搜索入口或关键词"
                  aria-label="站内搜索"
                  className="w-full bg-transparent text-sm font-label text-foreground-900 outline-none placeholder:text-foreground-400"
                />
              </div>

              {searchFocus && (
                <div className="absolute right-0 top-12 w-72 rounded-lg border border-background-200 bg-background-50 p-4">
                  <p className="text-xs font-label text-foreground-500">热门搜索</p>
                  <div className="mt-3 flex flex-wrap gap-2">
                    {hotSearches.map((item) => (
                      <button
                        key={item}
                        type="button"
                        onClick={() => setKeyword(item)}
                        className="cursor-pointer whitespace-nowrap rounded-full border border-background-200 bg-background-100 px-3 py-1.5 text-xs font-label text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
                      >
                        {item}
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <a
              href="#entries"
              className="hidden cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-label font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
            >
              直达最新入口
            </a>

            <button
              type="button"
              onClick={() => setMenuOpen((prev) => !prev)}
              aria-label="切换菜单"
              aria-expanded={menuOpen}
              className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-800 transition-colors hover:bg-background-100 lg:hidden"
            >
              <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <nav className="flex flex-col px-4 py-3" aria-label="移动端导航">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="whitespace-nowrap rounded-md px-3 py-3 text-sm font-label text-foreground-800 transition-colors hover:bg-background-100 hover:text-primary-600"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#entries"
              onClick={() => setMenuOpen(false)}
              className="mt-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-center text-sm font-label font-medium text-background-50"
            >
              直达最新入口
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}